import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
   cardHeader: {
      "& .MuiCardHeader-title": { fontSize: "20px" },
   },
});

export default useStyles;
